import dynamic from 'next/dynamic';
const ObjectPage  = dynamic(() => import('./ObjectPage'));

export default ObjectPage;
